import React from 'react'
import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { TrustPilotStars } from 'components/Common/TrustIndicators/TrustPilotStars'
import { TrustPilotLogo } from 'components/Common/TrustIndicators/TrustPilotLogo'
import ClickableLink from '../Clickable/ClickableLink'
import Divider from 'LuxKit/Divider'
import TrustPilotCarousel from './TrustPilotCarousel'
import styled from 'styled-components'
import { rem } from 'polished'

const TRUST_PILOT_LINK = 'https://trustpilot.com/review/luxuryescapes.com'

const LOGO_SIZE = {
  desktop: { height: '20', width: '83' },
  mobile: { height: '18', width: '66' },
}

const StyledDivider = styled(Divider)`
  margin: ${rem(16)} 0;
`

function TrustPilotSection() {
  let year = new Date().getFullYear()
  if (new Date() < new Date(year, 6, 1)) year -= 1
  return (
    <Group fullHeight direction="vertical" horizontalAlign="center" verticalAlign="center" gap={8}>
      <BodyText weight="bold" variant="medium" colour="primary-dark">
        <FormattedMessage
          id="hQwHDO6rS-4CV3wNf0ve"
          defaultMessage="Trusted by over 1,000,000 travellers in {year}"
          description="Trust message showing number of travellers and the year"
          values={{ year }}
        />
      </BodyText>
      <Group direction="horizontal" gap={12} verticalAlign="center">
        <Heading variant="heading4">
          <FormattedMessage
            id="ve6S8B0TPxBUZNJxg03u"
            defaultMessage="'Excellent'"
            description="TrustPilot excellent rating label in the trust review section section"
          />
        </Heading>
        <TrustPilotStars width="108" height="20" />
      </Group>
      <Group direction="horizontal" gap={12} verticalAlign="end">
        <TrustPilotLogo width={LOGO_SIZE.desktop.width} height={LOGO_SIZE.desktop.height} />
        <ClickableLink href={TRUST_PILOT_LINK} target="_blank">
          <BodyText underline colour="neutral-two" variant="medium" wrap="no-wrap">
            <FormattedMessage
              id="Ao9J5aBj816K-J3umJis"
              defaultMessage="10K reviews"
              description="Display text showing the total number of TrustPilot reviews for the brand rating"
            />
          </BodyText>
        </ClickableLink>
      </Group>
      <StyledDivider kind="primary" />
      <TrustPilotCarousel />
    </Group>
  )
}

export default TrustPilotSection
